import { useEffect, useCallback } from 'react';

export const useAuthKey = () => {
  // console.log(process.env.REACT_APP_API_apiBaseUrl);
  const baseUrl = 'DOF-' + process.env.REACT_APP_API_apiBaseUrl + '-AuthData';
  // console.log('baseUrl:', baseUrl);
  // localStorage.setItem(
  //   'token',
  //   '%y+0%XA?O?+KV1Q?|C+hbG#?O?+I(;I1/?+9.%y+lb<l;X3V;ZX+u:<1lIj-?/$AyO$:wOSI[I~5hb<(?O?+]:X+h#3dhdGhpI?w?#Gh)b~(?O?I4/;#4M]A>M$=5I?w?Z<1h!<w?O?+]:X+h#3dhdGhpQH}u#2/-b29[#y5nb3:u!<4?|C+lb<^pb$I?O~51bGw[I~}l#2lnb~^0!<9uIj-?(E0?|C+lb<l;X3V;ZX+0%X@lIj-?MjE?|C+lb<l;X3V;ZX+0%X@lMSI6IjM?|C+=ZX@h#n}tZ<50Ij-?VE4&}(1+(yI[In/0:X}1#yI6I=^jdGl2ZSI[InV;ZX+f!<Q?O~51bGw[In}lbX@fbG9n!<4?O?IwI?w?:~>):2tf!<Q?O~51bGw[I~}p#3}y!</0X2l=Ijpud<>[|C+=!X/0#~ljd^9u:<1lIjpud<>[|C+?bG9j!19u:<1lIjpud<>[|C+tb2Q>Ij-?OSwyMCwyMSw0/?w2MCw>O]#[MSI[I~1)Z$I?O?I4|$E>|$E;|$E0|$E2|$E3|$E4|$E5|$Iw|$I>|$Iy|$I;|$I0|$I1|$I2|$I3|$I4|$Mw|$M0|$Qy|$Q5|$(;|$:w|$E;/?w>/$I[M]&>|$E4M?w5M]Q[O]I3|$=1/Sw5/]:[O]:3|$=3/Sw5/;:[O]#3|$=3OCw5/;=[O]&w|$=4MSw5O$I[O]&1|$=5Myw5O]:[M]AwMCw>M$A1|$EwM$:[M]AwOCw>M$A5|$EwM]E[M]A>M?w>/]=>|$EwM]([M]A>/?w>M$E3|$EwMjI[M]Ay/Cw>M$I1|$EwMj:[M]AyOCw>M$I5|$EwM;A[M]E>/Sw>M]Iy|$E>Mj([M]E;/Cw>M]M1|$E>/$I[M]E0Myw>M]Q0|$E>/$([M]E0OCw>M]Q5|$E;O]E[M]M5M?w>M;=;|$E;O]Q[M]M5/Sw>M;=3|$E;O]=[M]QwMCw>/$Ay|$E0M$M[M]Qw/yw>/$Ew|$E0M]E[M]QyMyw>/$I3|$E0Mj&[M]QyOSw>/$M;|$E0M;&[M]Q0MCw>/$Q>|$E0/$:[M]Q0OSw>/$(w|$E0/]E[M]Q1M?w>/$(;|$E0/]Q[M]Q1/Sw>/$(2|$E0/]#[M]Q1OCw>/$(5|$E0/jA[M]Q2MSw>/$:y|$E0/jM[M]Q2/Cw>/$#4|$E0/;=[M]Q4MCw>/$&y|$E0O$M[M]Q4/Cw>/$&1|$E0O$:[M]Q4/yw>/$=w|$E0O]E[M]Q5M?w>/$=;|$E0O]:[M]Q5/yw>/$=4|$E1M$A[M](>OCw>/]A>|$E1M$I[M](wMyw>/]A0|$E1M$:[M](>MCw>/]Ey|$E1M]M[M](>/Cw>/]E1|$E1M]#[M](>OSw5M]#[M](yMCw>/]I;|$E1MjQ[M](y/Sw>/]I4|$E1Mj=[M](;MCw>/]M>|$E1M;#[M](;OSw>/]Qw|$E1/$E[M](0/Sw>/]Q2|$E1/$&[M](0OSw>/](4|$E1/]=[M](2M?w>/]:;|$E1/jQ[M](2/Sw>/]:2|$E1/j#[M](3MSw>/]#y|$E1/;=[M](4MCw>/]&1|$E1O$:[M](3Myw>/]#0|$E1O$&[M](5/Sw>/]=2|$E1O]&[M]:wM?w>/jEy|$E2M]M[M]:>/Cw>/jE3|$E2M]&[M]:yMSw>/jIy|$E2MjQ[M]:y/Sw>/jI2|$E2Mj#[M]:;MSw>/jM0|$E2M;([M]:;/?w>/jM4|$E2M;=[M]:0MCw>/jM3|$E2/$I[M]:0Myw>/jQ0|$E2/$([M]:0/?w>/jQ3|$E2/]A[M]:1M?w>/j(1|$E2/]:[M]:1/yw>/j(4|$E2/]Q[M]:1OSw>/j:w|$E2/jE[M]:2M?w>/j:;|$E2/jQ[M]:2/?w>/j:3|$E2/j&[M]:3MSw>/j#y|$E2/;M[M]:3/Cw>/j#1|$E2/;:[M]:3OSw>/j&w|$E2O$E[M]:4M?w>/j&;|$E2O$Q[M]A>/Cw>/;E3|$E3M]&[M]#>OSw>/;I>|$E3MjM[M]#y/Cw>/;I1|$E3Mj:[M]#y/yw>/;I4|$E3M;I[M]#;/yw>/;M4|$E3M;=[M]#0MCw>/;M1|$E3/$E[M]#3Myw>/;#1|$EwM$Q[M]#4MCw>/;#5|$E3O$E[M]&2/Sw>/;&2|$E3O]([M]#5/yw>/;=y|$EwM$I3|$EwM$Iy|$I[MSw4|$:y|$=5M?I[I~5ld3/j!Gw?O~51bGw[I~lhdCI6M]#3O]M0M;M3MCw?ZXhwIj->/;#5M;Q;/j#w|C+;d2l0!^9[b2dpb?I6IjE?|C+;d2l0:2hfZGV;!<du:X}pb24?O?I>|]A[MS0>|$ItMSw;|]E[My0y|$MtMyw;|]Q[My01|$Mt/?w;|]A[/C0w|$(tMSw1|]A[/S04|$(tMyw1|]Q[/S01|$(t/?w1|]M>|$(t/$E[/S01MSw1|]#[/S03MSw1|]=[/S05MSw1|]Ew|$(tM]E[/S0>M?w1|]EyMSw1|]EyM?w1|]E0|$(tM]=[/S0>/Sw1|]E2|$(tM]#[/S0>OCw1|]=y|$(tM]M[/S0y|$(tMjA[/S0yMSw1|]Iy|$(tMjM[/S0y/Cw1|]I1|$(tMj:[/S0y/yw1|]I4|$(tMj=[/S0;MCw1|]My|$(tM;M[/S0>MjM[/S0;/Cw1|]M1|$(tM;:[/S0;/yw1|]M4|$(tM]I0|$(tM]I1|$:tMSw2|]I[/?0;|$:t/Cw2|]([/?0w|$#tMSw4|]A[OS0>|$=tM?w5|]M[OS0w|$Ew|]M[M]At/Cw>MS0w|$E;|]E[M]MtM?w>My0;|$E;|]Q[M]Mt/Sw>My02|$E;|]#[M]MtOCw>My05|$E;|]Ew|$E;|]A[M]MtM]E[M]MtM]I[M]MtM]M[M]MtM]Q[M]MtM]([M]MtM]:[M]MtM]#[M]MtM]&[M]MtM]=[M]MtMjA[M]MtMjE[M]MtMjI[M]MtMjM[M]MtMjQ[M]MtMj([M]MtMj:[M]MtMj&[M]MtMj#[M]MtMj=[M]MtM;A[M]QtMCw>/C0>|$E0|]I[M]QtMyw>/S0y|$E1|]E[M](tMyw>/S00|$E1|]([M](t/?w>/S03|$E1|]&[M](tOSw>/S0>MCw>/S0>MSw>/S0>M?w>/S0>Myw>/S0>/Cw>/?0y|$E3|]A[M]&tMCw>OS0>|$E5|]I[M]=tMyw>OS00|$E5|]([M]=t/?w>OS03|$E5|]&[M]=tOSw>OS0>MCw>OS0>MSw>OS0w|$E5|]Ey|$E5|]E;|$E5|]E0|$E5|]E1|$E5|]E2|$E5|]E3|$E5|]E4|$E5|]E5|$E5|]Iw|$E5|]I>|$E5|]Iy|$E5|]I;|$E5|]I0|$Iw|]A[MjEtMCwyMS0>|$I>|]I[MjEtMywyMS00|$I>|]([MjEt/?wyMS03|$I>|]&[MjEtOSwyMS0>MCwyMS0>MSwyMS0>M?wyMS0>MywyMS0>/CwyMS0>/SwyMS0>/?wyMS0>/ywyMS0>OCwyMS0>OSwyMS0yMCwyM?0w|$I;|]A[MjMtMSwyMy0y|$I0|]A[MjQtMSwy/C0y|$I0|]M[MjQt/Cwy/C01|$I0|]:[Mj(tMCwy/?0w|$I2|]E[Mj#tM?wy/y0;|$I3|]Q[Mj#t/?wy/y03|$I3|]&[Mj#tOSw;MC0>|$Mw|]I[M;AtMyw;MC00|$Mw|]([M;At/?w;MS0>|$M>|]I[M;EtMyw;MS00|$M>|]([M;ItMSw;M?0y|$M;|]E[M;MtM?w;/C0>|$M1|]E[M;(tM?w;/?0y|$M2|]E[M;#tMSw;/y0y|$M4|]E[M;&tM?w;OS0>|$M5|]I[M;=tMCw0MC0>|$Qw|]M[/$AtM?w0MC00|$Q>|]E[/$EtM?w0MS0;|$Q>|]Q[/$Et/Sw0MS02|$Q>|]#[/$EtOCw0MS05|$Q>|]Ew|$Q>|]E[/$EtM]E[/$ItM?w0M?0>|$Qy|]M[/$It/Cw0M?01|$Qy|]:[/$MtM?w0My0>|$Q0|]E[/]AtMSw1MC0y|$(>|]E[/]EtMCw1MS0y|$(>|]M[/]Et/Cw1MS01|$(>|]:[/]Et/yw1M?0w|$(y|]E[/]MtMSw1/C0>|$(1|]E[/]:tMSw1/?0y|$(4|]E[/]&tM?w1OS0>|$(5|]I[/jEtMSw2M?0>|$:;|]A[/jMtMSw2/C0>|$:1|]A[/j(tMSw2/S0y|$:2|]A[/j:tMSw2/y0>|$:3|]I[/j#tMyw2OC0>|$:4|]A[/j&tM?w2OC0;|$:4|]Q[/j=tMSw2OS0y|$:5|]M[/j=t/Cw2OS01|$:5|]:[/j=t/yw2OS04|$:5|]=[/j=tM]A[/j=tM]E[/j=tM]I[/j=tM]M[/j=tM]Q[/j=tM]([/j=tM]:[/j=tM]#[/j=tM]&[/j=tM]=[/j=tMjA[/j=tMjE[/j=tMjI[/j=tMjM[/j=tMjQ[/j=tMj([/j=tMj:[/j=tMj#[/j=tMj&[/j=tMj=[/j=tM;A[/j=tM;E[/j=tM;I[/j=tM;M[/j=tM;Q[/j=tM;([/j=tM;:[/j=tM;#[/j=tM;&[/j=tM;=[/j=t/$A[/j=t/$E[/j=t/$I[/j=t/$M[/j=t/$Q[XG43MC0>|$#>|]E[/;ItMSw3My0>|$#0|]E[/;QtM?w3/S0>|$#1|]I[/;(tMyw3/?0>In0.jC3Ej/0/&;H46tHI:K>h$3>&j4&wt}Q>)&=~$>&7(##'
  // );
  // localStorage.setItem(
  //   baseUrl,
  //   '%y+0%XA?O?+KV1Q?|C+hbG#?O?+I(;I1/?+9.%y+lb<l;X3V;ZX+u:<1lIj-?/$AyO$:wOSI[I~5hb<(?O?+]:X+h#3dhdGhpI?w?#Gh)b~(?O?I4/;#4M]A>M$=5I?w?Z<1h!<w?O?+]:X+h#3dhdGhpQH}u#2/-b29[#y5nb3:u!<4?|C+lb<^pb$I?O~51bGw[I~}l#2lnb~^0!<9uIj-?(E0?|C+lb<l;X3V;ZX+0%X@lIj-?MjE?|C+lb<l;X3V;ZX+0%X@lMSI6IjM?|C+=ZX@h#n}tZ<50Ij-?VE4&}(1+(yI[In/0:X}1#yI6I=^jdGl2ZSI[InV;ZX+f!<Q?O~51bGw[In}lbX@fbG9n!<4?O?IwI?w?:~>):2tf!<Q?O~51bGw[I~}p#3}y!</0X2l=Ijpud<>[|C+=!X/0#~ljd^9u:<1lIjpud<>[|C+?bG9j!19u:<1lIjpud<>[|C+tb2Q>Ij-?OSwyMCwyMSw0/?w2MCw>O]#[MSI[I~1)Z$I?O?I4|$E>|$E;|$E0|$E2|$E3|$E4|$E5|$Iw|$I>|$Iy|$I;|$I0|$I1|$I2|$I3|$I4|$Mw|$M0|$Qy|$Q5|$(;|$:w|$E;/?w>/$I[M]&>|$E4M?w5M]Q[O]I3|$=1/Sw5/]:[O]:3|$=3/Sw5/;:[O]#3|$=3OCw5/;=[O]&w|$=4MSw5O$I[O]&1|$=5Myw5O]:[M]AwMCw>M$A1|$EwM$:[M]AwOCw>M$A5|$EwM]E[M]A>M?w>/]=>|$EwM]([M]A>/?w>M$E3|$EwMjI[M]Ay/Cw>M$I1|$EwMj:[M]AyOCw>M$I5|$EwM;A[M]E>/Sw>M]Iy|$E>Mj([M]E;/Cw>M]M1|$E>/$I[M]E0Myw>M]Q0|$E>/$([M]E0OCw>M]Q5|$E;O]E[M]M5M?w>M;=;|$E;O]Q[M]M5/Sw>M;=3|$E;O]=[M]QwMCw>/$Ay|$E0M$M[M]Qw/yw>/$Ew|$E0M]E[M]QyMyw>/$I3|$E0Mj&[M]QyOSw>/$M;|$E0M;&[M]Q0MCw>/$Q>|$E0/$:[M]Q0OSw>/$(w|$E0/]E[M]Q1M?w>/$(;|$E0/]Q[M]Q1/Sw>/$(2|$E0/]#[M]Q1OCw>/$(5|$E0/jA[M]Q2MSw>/$:y|$E0/jM[M]Q2/Cw>/$#4|$E0/;=[M]Q4MCw>/$&y|$E0O$M[M]Q4/Cw>/$&1|$E0O$:[M]Q4/yw>/$=w|$E0O]E[M]Q5M?w>/$=;|$E0O]:[M]Q5/yw>/$=4|$E1M$A[M](>OCw>/]A>|$E1M$I[M](wMyw>/]A0|$E1M$:[M](>MCw>/]Ey|$E1M]M[M](>/Cw>/]E1|$E1M]#[M](>OSw5M]#[M](yMCw>/]I;|$E1MjQ[M](y/Sw>/]I4|$E1Mj=[M](;MCw>/]M>|$E1M;#[M](;OSw>/]Qw|$E1/$E[M](0/Sw>/]Q2|$E1/$&[M](0OSw>/](4|$E1/]=[M](2M?w>/]:;|$E1/jQ[M](2/Sw>/]:2|$E1/j#[M](3MSw>/]#y|$E1/;=[M](4MCw>/]&1|$E1O$:[M](3Myw>/]#0|$E1O$&[M](5/Sw>/]=2|$E1O]&[M]:wM?w>/jEy|$E2M]M[M]:>/Cw>/jE3|$E2M]&[M]:yMSw>/jIy|$E2MjQ[M]:y/Sw>/jI2|$E2Mj#[M]:;MSw>/jM0|$E2M;([M]:;/?w>/jM4|$E2M;=[M]:0MCw>/jM3|$E2/$I[M]:0Myw>/jQ0|$E2/$([M]:0/?w>/jQ3|$E2/]A[M]:1M?w>/j(1|$E2/]:[M]:1/yw>/j(4|$E2/]Q[M]:1OSw>/j:w|$E2/jE[M]:2M?w>/j:;|$E2/jQ[M]:2/?w>/j:3|$E2/j&[M]:3MSw>/j#y|$E2/;M[M]:3/Cw>/j#1|$E2/;:[M]:3OSw>/j&w|$E2O$E[M]:4M?w>/j&;|$E2O$Q[M]A>/Cw>/;E3|$E3M]&[M]#>OSw>/;I>|$E3MjM[M]#y/Cw>/;I1|$E3Mj:[M]#y/yw>/;I4|$E3M;I[M]#;/yw>/;M4|$E3M;=[M]#0MCw>/;M1|$E3/$E[M]#3Myw>/;#1|$EwM$Q[M]#4MCw>/;#5|$E3O$E[M]&2/Sw>/;&2|$E3O]([M]#5/yw>/;=y|$EwM$I3|$EwM$Iy|$I[MSw4|$:y|$=5M?I[I~5ld3/j!Gw?O~51bGw[I~lhdCI6M]#3O]M0M;M3MCw?ZXhwIj->/;#5M;Q;/j#w|C+;d2l0!^9[b2dpb?I6IjE?|C+;d2l0:2hfZGV;!<du:X}pb24?O?I>|]A[MS0>|$ItMSw;|]E[My0y|$MtMyw;|]Q[My01|$Mt/?w;|]A[/C0w|$(tMSw1|]A[/S04|$(tMyw1|]Q[/S01|$(t/?w1|]M>|$(t/$E[/S01MSw1|]#[/S03MSw1|]=[/S05MSw1|]Ew|$(tM]E[/S0>M?w1|]EyMSw1|]EyM?w1|]E0|$(tM]=[/S0>/Sw1|]E2|$(tM]#[/S0>OCw1|]=y|$(tM]M[/S0y|$(tMjA[/S0yMSw1|]Iy|$(tMjM[/S0y/Cw1|]I1|$(tMj:[/S0y/yw1|]I4|$(tMj=[/S0;MCw1|]My|$(tM;M[/S0>MjM[/S0;/Cw1|]M1|$(tM;:[/S0;/yw1|]M4|$(tM]I0|$(tM]I1|$:tMSw2|]I[/?0;|$:t/Cw2|]([/?0w|$#tMSw4|]A[OS0>|$=tM?w5|]M[OS0w|$Ew|]M[M]At/Cw>MS0w|$E;|]E[M]MtM?w>My0;|$E;|]Q[M]Mt/Sw>My02|$E;|]#[M]MtOCw>My05|$E;|]Ew|$E;|]A[M]MtM]E[M]MtM]I[M]MtM]M[M]MtM]Q[M]MtM]([M]MtM]:[M]MtM]#[M]MtM]&[M]MtM]=[M]MtMjA[M]MtMjE[M]MtMjI[M]MtMjM[M]MtMjQ[M]MtMj([M]MtMj:[M]MtMj&[M]MtMj#[M]MtMj=[M]MtM;A[M]QtMCw>/C0>|$E0|]I[M]QtMyw>/S0y|$E1|]E[M](tMyw>/S00|$E1|]([M](t/?w>/S03|$E1|]&[M](tOSw>/S0>MCw>/S0>MSw>/S0>M?w>/S0>Myw>/S0>/Cw>/?0y|$E3|]A[M]&tMCw>OS0>|$E5|]I[M]=tMyw>OS00|$E5|]([M]=t/?w>OS03|$E5|]&[M]=tOSw>OS0>MCw>OS0>MSw>OS0w|$E5|]Ey|$E5|]E;|$E5|]E0|$E5|]E1|$E5|]E2|$E5|]E3|$E5|]E4|$E5|]E5|$E5|]Iw|$E5|]I>|$E5|]Iy|$E5|]I;|$E5|]I0|$Iw|]A[MjEtMCwyMS0>|$I>|]I[MjEtMywyMS00|$I>|]([MjEt/?wyMS03|$I>|]&[MjEtOSwyMS0>MCwyMS0>MSwyMS0>M?wyMS0>MywyMS0>/CwyMS0>/SwyMS0>/?wyMS0>/ywyMS0>OCwyMS0>OSwyMS0yMCwyM?0w|$I;|]A[MjMtMSwyMy0y|$I0|]A[MjQtMSwy/C0y|$I0|]M[MjQt/Cwy/C01|$I0|]:[Mj(tMCwy/?0w|$I2|]E[Mj#tM?wy/y0;|$I3|]Q[Mj#t/?wy/y03|$I3|]&[Mj#tOSw;MC0>|$Mw|]I[M;AtMyw;MC00|$Mw|]([M;At/?w;MS0>|$M>|]I[M;EtMyw;MS00|$M>|]([M;ItMSw;M?0y|$M;|]E[M;MtM?w;/C0>|$M1|]E[M;(tM?w;/?0y|$M2|]E[M;#tMSw;/y0y|$M4|]E[M;&tM?w;OS0>|$M5|]I[M;=tMCw0MC0>|$Qw|]M[/$AtM?w0MC00|$Q>|]E[/$EtM?w0MS0;|$Q>|]Q[/$Et/Sw0MS02|$Q>|]#[/$EtOCw0MS05|$Q>|]Ew|$Q>|]E[/$EtM]E[/$ItM?w0M?0>|$Qy|]M[/$It/Cw0M?01|$Qy|]:[/$MtM?w0My0>|$Q0|]E[/]AtMSw1MC0y|$(>|]E[/]EtMCw1MS0y|$(>|]M[/]Et/Cw1MS01|$(>|]:[/]Et/yw1M?0w|$(y|]E[/]MtMSw1/C0>|$(1|]E[/]:tMSw1/?0y|$(4|]E[/]&tM?w1OS0>|$(5|]I[/jEtMSw2M?0>|$:;|]A[/jMtMSw2/C0>|$:1|]A[/j(tMSw2/S0y|$:2|]A[/j:tMSw2/y0>|$:3|]I[/j#tMyw2OC0>|$:4|]A[/j&tM?w2OC0;|$:4|]Q[/j=tMSw2OS0y|$:5|]M[/j=t/Cw2OS01|$:5|]:[/j=t/yw2OS04|$:5|]=[/j=tM]A[/j=tM]E[/j=tM]I[/j=tM]M[/j=tM]Q[/j=tM]([/j=tM]:[/j=tM]#[/j=tM]&[/j=tM]=[/j=tMjA[/j=tMjE[/j=tMjI[/j=tMjM[/j=tMjQ[/j=tMj([/j=tMj:[/j=tMj#[/j=tMj&[/j=tMj=[/j=tM;A[/j=tM;E[/j=tM;I[/j=tM;M[/j=tM;Q[/j=tM;([/j=tM;:[/j=tM;#[/j=tM;&[/j=tM;=[/j=t/$A[/j=t/$E[/j=t/$I[/j=t/$M[/j=t/$Q[XG43MC0>|$#>|]E[/;ItMSw3My0>|$#0|]E[/;QtM?w3/S0>|$#1|]I[/;(tMyw3/?0>In0.jC3Ej/0/&;H46tHI:K>h$3>&j4&wt}Q>)&=~$>&7(##'
  // );
  //when loggin is integrated these both needs to be pushed to local storage there
  /**
   * Convert encoded alpha string back to number.
   * IMPORTANT:
   * Replace this logic with the exact same logic from your Angular commonService.alphabetToNumber()
   */
  const alphabetToNumber = useCallback((value: string): string => {
    // Example placeholder only.
    // You must paste your actual Angular alphabetToNumber logic here.
    return value;
  }, []);

  /**
   * Store Authorization key in localStorage
   */
  // const storeAuthKey = useCallback((result?: any) => {
  //   if (!result?.body) return;

  //   const parsed =
  //     typeof result.body === 'string'
  //       ? JSON.parse(result.body || '{}')
  //       : result.body;

  //   const key = parsed.Authorization_key;

  //   if (key) {
  //     localStorage.setItem('AuthorizationKey', key);
  //     //// console.log('Authorization Key stored:', key);
  //   }
  // }, []);

  const storeAuthKey = useCallback((result?: any) => {
    if (!result) return;

    // ← Authorization_key is at root level, not inside result.body
    const key = result?.Authorization_key;

    if (key) {
      localStorage.setItem('AuthorizationKey', key);
      // console.log('AuthorizationKey stored →', key);
    }
  }, []);

  /**
   * Fetch a fresh Authorization key
   */
  const manualRefetch = useCallback(async () => {
    try {
      const response = await fetch(
        'https://eeqzof4a8g.execute-api.ap-south-1.amazonaws.com/api/oauth_test',
        {
          method: 'GET',
          headers: {
            Accept: 'application/json, text/plain, */*',
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const result = await response.json();
      // console.log('Auth key API result →', result); // ← add this
      // console.log('result.body →', result?.body);
      storeAuthKey(result);
    } catch (err) {
      console.error('Auth key fetch failed:', err);
    }
  }, [storeAuthKey]);

  /**
   * Check whether stored Authorization key is valid or expired
   */
  // const checkKeyValidTime = useCallback(() => {
  //   const key = localStorage.getItem('AuthorizationKey');

  //   if (!key) return;

  //   const inputStr = key.toString();

  //   const first6 = inputStr.slice(0, 6);
  //   const last6 = inputStr.slice(-6);
  //   const middle = inputStr.slice(6, -6);

  //   /**
  //    * Same as Angular:
  //    * const test = this.commonService.alphabetToNumber(middle);
  //    */
  //   const test = alphabetToNumber(middle);

  //   const dateexpires = parseInt(test, 10) / 1000;

  //   const dateexpiresObj = new Date(dateexpires * 1000);

  //   const currentDate = new Date();

  //   // // console.log({
  //   //   key: inputStr,
  //   //   first6,
  //   //   last6,
  //   //   middle,
  //   //   convertedMiddle: test,
  //   //   expiryDate: dateexpiresObj,
  //   //   currentDate,
  //   // });

  //   if (dateexpiresObj < currentDate || first6 !== last6) {
  //     //// console.log('Authorization key expired or invalid → refetching...');
  //     manualRefetch();
  //   }
  // }, [alphabetToNumber, manualRefetch]);
  // Replace checkKeyValidTime with this simpler version
  const checkKeyValidTime = useCallback(() => {
    const key = localStorage.getItem('AuthorizationKey');
    if (!key) {
      manualRefetch();
    }
  }, [manualRefetch]);
  /**
   * On mount:
   * If Authorization is missing, fetch new key.
   * If key exists, validate it.
   */
  useEffect(() => {
    const existingKey = localStorage.getItem('AuthorizationKey');

    if (!existingKey) {
      //// console.log('No stored Authorization key → fetching...');
      manualRefetch();
    } else {
      checkKeyValidTime();
    }
  }, [manualRefetch, checkKeyValidTime]);

  /**
   * Network online/offline events
   */
  useEffect(() => {
    const handleOnline = () => {
      //// console.log('Network Online...');
      checkKeyValidTime();
    };

    const handleOffline = () => {
      // console.log('Network Offline...');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [checkKeyValidTime]);

  /**
   * Check key validity every 3 seconds
   */
  useEffect(() => {
    const interval = setInterval(() => {
      if (localStorage.getItem('AuthorizationKey')) {
        checkKeyValidTime();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [checkKeyValidTime]);

  /**
   * Optional full refresh every 55 minutes
   */
  useEffect(() => {
    const interval = setInterval(() => {
      //// console.log('Scheduled Authorization key refresh...');
      manualRefetch();
    }, 3300000);

    return () => clearInterval(interval);
  }, [manualRefetch]);

  return {
    manualRefetch,
    checkKeyValidTime,
  };
};

export const getHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json, text/plain, */*',
  Authorization: localStorage.getItem('AuthorizationKey') ?? '', // ← dynamic, from authkey API
  Token: localStorage.getItem('token') ?? '', // ← from login response
});
